import { ConversionService } from 'app/_directives/conversionService';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { TsoNumberSequence } from '../custom';
import { config } from 'angular/utils/config';

class UnbundledToBundledConversionCtrl implements ng.IController {
    public onAnyAmountChange: () => void;

    public bidCapacity: number;
    public tsosWhichSupportConversion: TsoNumberSequence;
    public model: LongTermComfortBid;
    public indexOfTsoToPerformConversionFor: { boundVal: string };
    public networkPoint: NetworkPointDto;
    public runtime: DateInterval;
    public tsoConfig: AuctionConfigDto;
    public monthsInRuntime: number;
    public stageConfig = config;

    constructor(
        private conversionService: ConversionService,
        public INCLUDE
    ) {
        this.indexOfTsoToPerformConversionFor = { boundVal: null };
        this.tsosWhichSupportConversion =
            conversionService.getTsosWhichSupportConversion(
                this.networkPoint.bundled,
                this.tsoConfig.conversionSupported0,
                this.tsoConfig.conversionSupported1
            );
    }

    $onInit(): void {
        if (
            this.model.conversions &&
            this.model.conversions[0] &&
            this.model.conversions[0].conversion0
        ) {
            this.indexOfTsoToPerformConversionFor.boundVal = '0';
        } else if (
            this.model.conversions &&
            this.model.conversions[0] &&
            this.model.conversions[0].conversion1
        ) {
            this.indexOfTsoToPerformConversionFor.boundVal = '1';
        }
    }

    $onDestroy(): void {
        this.onAnyAmountChange && this.onAnyAmountChange();
    }

    public resetConversionSettings(): void {
        this.model.conversions = [
            { conversion0: undefined, conversion1: undefined }
        ];

        this.onAnyAmountChange && this.onAnyAmountChange();

        if (
            angular.isUndefined(
                this.model.conversions[0][
                    'conversion' +
                        this.indexOfTsoToPerformConversionFor.boundVal
                ]
            )
        ) {
            this.model.conversions[0][
                'conversion' + this.indexOfTsoToPerformConversionFor.boundVal
            ] = <ConversionDto>{};
            this.model.conversions[0][
                'conversion' + this.indexOfTsoToPerformConversionFor.boundVal
            ].intervals = [];
        }

        this.addRuntimeConversion();
    }

    public addRuntimeConversion() {
        let runtimeConversion = {};
        if (
            this.tsoConfig[
                'runtimeForConversionSupported' +
                    this.indexOfTsoToPerformConversionFor.boundVal
            ]
        ) {
            runtimeConversion = {
                amount: {},
                interval: angular.copy(this.runtime)
            };
        } else {
            runtimeConversion = {
                amount: {}
            };
        }

        this.model.conversions[0][
            'conversion' + this.indexOfTsoToPerformConversionFor.boundVal
        ].intervals.push(runtimeConversion);
    }

    public deleteRuntimeConversion(index) {
        this.model.conversions[0][
            'conversion' + this.indexOfTsoToPerformConversionFor.boundVal
        ].intervals.splice(index, 1);
    }

    public mapConversionIntervalDtosToDateIntervals(
        conversionIntervalDtos: ConversionIntervalDto[]
    ): DateInterval[] {
        return conversionIntervalDtos.map(
            (conversionIntervalDto) => conversionIntervalDto.interval
        );
    }

    public addConversionRuntimePossible() {
        return (
            this.model.conversions[0][
                'conversion' + this.indexOfTsoToPerformConversionFor.boundVal
            ].intervals.length <
            Math.round(
                moment
                    .duration(
                        moment(this.runtime.end).diff(
                            moment(this.runtime.start)
                        )
                    )
                    .asMonths()
            )
        );
    }
}

angular.module('app').component('pkpUnbundledToBundledConversion', {
    controller: UnbundledToBundledConversionCtrl,
    template:
        require('app/conversion/unbundled-to-bundled-conversion.component.html'),
    bindings: {
        networkPoint: '=',
        runtime: '<',
        model: '=',
        form: '=',
        tsoConfig: '=',
        bidCapacity: '=',
        onAnyAmountChange: '&?'
    }
});
